import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showLoading, showAlert } from "../Actions/GeneralActions";
import { headers } from "../../utills";
import {
  getClientDashboardData,
  getGuestDashboardData,
  getVendorDashboardData,
} from "../Actions/DashboardAction";

export const DashBoardMiddleware = {
  getClientDashBoard: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getClientDashboard,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getClientDashboardData(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Client DashBoard",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
  getVendorDashBoard: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getVendorDashboard,
            await headers.config()
          );

          if (data?.status == 200) {
            dispatch(hideLoading())
            resolve(true);
            dispatch(getVendorDashboardData(data?.data?.data));
            // console.log("getVendorDashboardData", data?.data);
          }
        } catch (error) {
          dispatch(hideLoading())
          reject(error);
          dispatch(
            showAlert({
              title: "Vendor DashBoard",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
  getGuestDashBoard: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            Apis.getGuestDashboard,
            await headers.config()
          );

          if (data?.status == 200) {
            resolve(true);
            dispatch(getGuestDashboardData(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Vendor DashBoard",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
